<template>
    <div class="page-cabinet-verification-profile-other-docs">
        <common-collapsible
            title="Документы организации"
            v-bind:attention="documents.length === 0 ? 'Загрузите документы' : ''"
            init-open
            start-collapsed-on-mobile
        >
            <div class="page-cabinet-verification-profile-other-docs__description">
                Загрузите следующие документы по организации:<br>
                1. Устав организации со всеми изменениями;<br>
                2. Документ, подтверждающий постановку на учет в налоговом органе;<br>
                3. Документ, подтверждающий государственную регистрацию организации (для организаций, зарегистрированных
                до 01.01.2017 – свидетельство о государственной регистрации юридического лица (ОГРН); для организаций,
                зарегистрированных с 01.01.2017 года – лист записи ЕГРЮЛ о создании юридического лица);<br>
                4. Решение уполномоченного органа управления о назначении единоличного исполнительного органа (решение
                единственного участника или протокол общего собрания участников);<br>
                5. Список участников (с указанием сведений о бенефициарных владельцах).<br>
                <p class="page-cabinet-verification-profile-other-docs__description-small">
                    Оператор платформы вправе запросить иные документы и сведения, необходимые для
                    идентификации/верификации и оценки рисков в соответствии с законодательством Российской Федерации и
                    внутренними правилами платформы.
                </p>
            </div>
            <div class="page-cabinet-verification-profile-other-docs__loaders">
                <common-drop-zone
                    v-bind:given-error="validationError"
                    v-bind:is-loading="uploadInProgress.length > 0"
                    v-on:change="uploadDocuments($event)"
                />
                <div
                    class="page-cabinet-verification-profile-other-docs__items"
                    v-if="documents.length > 0 || uploadInProgress.length > 0"
                >
                    <common-drop-zone-item
                        v-for="(name, index) in uploadInProgress"
                        v-bind:key="index"
                        v-bind:filename="name"
                        v-bind:is-loading="true"
                        v-bind:error="uploadErrors.includes(name)"
                    />
                    <common-drop-zone-item
                        v-for="document in documents"
                        v-bind:file="document"
                        v-bind:key="document.id"
                        v-bind:filename="document.filename_short"
                        v-on:delete="deletePhoto"
                    />
                </div>
                <template v-if="uploadErrors.length > 0">
                    <div
                        class="page-cabinet-verification-profile-other-docs__error"
                        v-for="(fileName, index) in uploadErrors"
                        v-bind:key="index"
                    >
                        Ошибка при загрузке файла: {{ fileName }}
                    </div>
                </template>
            </div>
        </common-collapsible>
    </div>
</template>

<script>
import { mapState } from 'vuex';
import { mainClient } from '~/network';

export default {
    name: 'page-cabinet-verification-profile-other-docs',
    props: {
        isTouched: {
            type: Boolean,
        },
    },
    data: () => ({
        // documents: [],
        // isGetDocumentsError: false,
        uploadErrors: [],
        uploadInProgress: [],
    }),
    computed: {
        ...mapState('verification/type', [
            'legalType',
        ]),
        ...mapState('users', [
            'getUserProfileResult',
            'getUserProfileIsLoading',

            'getUserPhotosResult',
            'getUserPhotosIsLoading',
            'getUserPhotosError',
        ]),
        user() {
            return this.$store.getters['users/user'];
        },
        isValid() {
            // return this.getUserPhotosResult?.photoOtherDocuments &&
            //     this.getUserPhotosResult.photoOtherDocuments.length > 0;
            return true;
        },
        validationError() {
            if (this.isTouched && !this.isValid) {
                return 'Загрузите фото';
            }
            return null;
        },
        documents() {
            return [
                ...this.getUserPhotosResult?.photoOtherDocuments || [],
            ];
        },
    },
    mounted() {
        if (!this.getUserPhotosResult && !this.getUserPhotosIsLoading) {
            this.getDocuments();
        }
    },
    methods: {
        getDocuments() {
            // this.isGetDocumentsError = false;
            // const { data, error } = await mainClient.users.requests.getUserPhotos({
            //     userId: this.user.id,
            // });
            // if (!error) {
            //     this.uploadInProgress = [];
            //     if (data.photoOtherDocuments && Array.isArray(data.photoOtherDocuments)) {
            //         this.documents = data.photoOtherDocuments;
            //     }
            // } else {
            //     this.isGetDocumentsError = true;
            // }
            this.$store.dispatch('users/getUserPhotos', {
                userId: this.user.id,
            });
        },
        async uploadDocuments(files) {
            if (files && files.length) {
                this.uploadErrors = [];
                this.uploadInProgress = [];

                for (const file of files) {
                    const payload = new FormData();
                    payload.append('image_file', file);

                    this.uploadInProgress.push(file.name);

                    const { error } = await mainClient.users.requests.updateUserPhoto({
                        userId: this.user.id,
                        type: 'photoOtherDocument',
                        formData: payload,
                    });

                    if (error) {
                        this.uploadErrors.push(file.name);
                        console.error(`Ошибка при загрузке ${file.name}:`, error);
                    }
                }

                this.getDocuments();
            }
        },
        async deletePhoto(id) {
            await mainClient.users.requests.deleteUserPhoto({
                userId: this.user.id,
                photoId: id,
            });
            this.getDocuments();
        },
    },
    watch: {
        isValid: {
            handler(newVal) {
                this.$emit('validation-update', { entityName: 'isJuridicalDocsDataValid', value: !!newVal });
            },
            immediate: true,
        },
        getUserPhotosIsLoading(newVal) {
            if (!newVal) {
                this.uploadInProgress = [];
            }
        },
    },
};
</script>

<style scoped lang="less">
@import '~theme';

.page-cabinet-verification-profile-other-docs {
    &__description {
        .typography-body();
        color: @color-gray-darker;
        &-small {
            .typography-caption();

            margin: 16px 0;
            color: @color-gray-main;
        }
    }
    &__loaders {
        display: flex;
        flex-direction: column;
        gap: 12px;
    }
    &__items {
        display: grid;
        grid-template-columns: repeat(3, minmax(0, 1fr));
        grid-gap: 12px;
    }
    &__error {
        .typography-caption();

        color: @color-accent-negative;
    }
    @media @media-sm-down {
        &__items {
            grid-template-columns: repeat(1, minmax(0, 1fr));
        }
    }
}
</style>
